import { Divider } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';

export const Separator = () => {
  return (
    <Divider orientation="vertical" flexItem color={colors.grey[120]} sx={{ margin: '-4px 0' }} />
  );
};
